import * as roles from '../../actionTypes/Roles/Roles'
const _ = require('underscore')

const initialState = {
  'rolesDetails': [
    {
      'Role_UID': '',
      'Role_Name': '',
      'Company_Name': '',
      'Role_Description': '',
      'UserName': ''
    }
  ],
  'userPermission': [
    {
      'Permission_Name': '',
      'Role_Name': ''
    }
  ],
  'permissionList': [
    {
      'Permission_Name': '',
      'Permission_UID': '',
      'Permission_Type': '',
      'Permission_Type_ID': null
    }
  ],
  'getRoleinfo': {
    'roles': {
      'Role_ID': null,
      'Role_IsActive': null,
      'Role_IsDefault': null,
      'Role_IsCorporate': null,
      'Role_Name': '',
      'Role_Description': '',
      'Role_CreatedBy': ''
    },
    'Permission': [
      {
        'Permission_ID': null,
        'Permission_UID': '',
        'Role_IsActive': null,
        'Permission_Name': '',
        'Permission_Description': '',
        'Role_CreatedBy': '',
        'isChecked': null
      }
    ],
    'IsOwner': 0
  },
  'state': true
}

export default function rolesDetails (state = initialState, action) {
  switch (action.type) {
    case roles.GET_PERMISSIONS:
      state.userPermission = action.userPermission
      return {
        ...state
      }
    case roles.GET_PERMISSIONS_LIST:
      let permissionList = _.filter(action.permissionList, function (value) {
        return value.Permission_Name !== 'EditDeviceSettings'
      })
      state.permissionList = permissionList
      return {
        ...state
      }
    case roles.GET_ROLES:
      state.rolesDetails = action.rolesDetails
      return {
        ...state
      }
    case roles.GET_ROLE_INFORMATION:
      state.getRoleinfo = action.getRoleinfo
      return {
        ...state
      }
    case roles.GET_ROLES_USERINFO:
      state.IsOwner = action.IsOwner
      return {
        ...state
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/store/roles.js